

<div class="mapimg">
	<traffic-google-map (callBack)="showDetail($event.type, $event.name, $event.stationId, $event.branch, $event.title, $event.address, $event.floor, $event.capacity, $event.village, $event.lat, $event.lng)"></traffic-google-map>
	<div class="map_in">
		<a (click)="callMap_getLocal()" role="button">以地圖中央尋找附近站點(點此返回我的位置)</a>
		
	</div>
</div>




<!--市區交通船-->
@if ( type == "BOAT") {
	<boat-traffic [name]="this.name" [stationId]="this.stationId" [title]="this.title" [address]="this.address" [branch]="this.branch" [floor]="this.floor" [capacity]="this.capacity" [village]="this.village" [lat]="this.lat" [lng]="this.lng" (callBack)="close()"/>
}
